// removed by extract-text-webpack-plugin
module.exports = {"main":"Header-main--32vOh","label":"Header-label--2KtJq","labelContent":"Header-labelContent--2iqPG","item":"Header-item--1ilFC","icon":"Header-icon--3gVjx","hint":"Header-hint--ANNY2","segmentNumber":"Header-segmentNumber--1U1MY","emptyListSegment":"Header-emptyListSegment--C1AGw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MapPanel/CreateRoute/Header/Header.scss
// module id = z4D3
// module chunks = 4